import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Calculator, Activity, TrendingUp, ArrowDown, CheckCircle } from 'lucide-react';

export const HeroSection = () => {
  const scrollToCalculator = () => {
    const element = document.getElementById('calculator');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1552674605-db6ffd4facb5?w=1920&q=80"
          alt="Fitness background"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background/95 via-background/85 to-background" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24 lg:py-32">
        <div className="max-w-3xl">
          {/* Badge */}
          <Badge className="mb-6 bg-primary/10 text-primary border-primary/20 px-4 py-1.5 text-sm font-medium">
            <Activity className="w-4 h-4 mr-2" />
            Athlete Edition Available
          </Badge>

          {/* Headline */}
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-foreground leading-tight mb-6">
            Know Your Body,
            <br />
            <span className="gradient-text">Optimize Performance</span>
          </h1>

          {/* Subheadline */}
          <p className="text-lg sm:text-xl text-muted-foreground mb-8 max-w-2xl">
            Professional BMI calculator with athlete-focused insights. Get instant metrics, 
            performance analysis, and track your progress — all without creating an account.
          </p>

          {/* Features List */}
          <div className="flex flex-wrap gap-4 mb-8">
            <div className="flex items-center gap-2 text-sm text-muted-foreground">
              <CheckCircle className="w-4 h-4 text-success" />
              <span>WHO BMI Categories</span>
            </div>
            <div className="flex items-center gap-2 text-sm text-muted-foreground">
              <CheckCircle className="w-4 h-4 text-success" />
              <span>Athlete Performance Bands</span>
            </div>
            <div className="flex items-center gap-2 text-sm text-muted-foreground">
              <CheckCircle className="w-4 h-4 text-success" />
              <span>Local Progress Tracking</span>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4">
            <Button
              size="lg"
              onClick={scrollToCalculator}
              className="btn-primary-gradient h-14 px-8 text-lg"
            >
              <Calculator className="w-5 h-5 mr-2" />
              Calculate Your BMI
            </Button>
            <Button
              variant="outline"
              size="lg"
              onClick={() => document.getElementById('features')?.scrollIntoView({ behavior: 'smooth' })}
              className="h-14 px-8 text-lg"
            >
              <TrendingUp className="w-5 h-5 mr-2" />
              Learn More
            </Button>
          </div>

          {/* Trust Indicators */}
          <div className="mt-12 pt-8 border-t border-border">
            <p className="text-sm text-muted-foreground mb-4">Trusted by fitness enthusiasts worldwide</p>
            <div className="flex flex-wrap gap-8 items-center">
              <div className="text-center">
                <p className="text-2xl font-bold text-foreground">100K+</p>
                <p className="text-xs text-muted-foreground">Calculations</p>
              </div>
              <div className="text-center">
                <p className="text-2xl font-bold text-foreground">4.9</p>
                <p className="text-xs text-muted-foreground">User Rating</p>
              </div>
              <div className="text-center">
                <p className="text-2xl font-bold text-foreground">Free</p>
                <p className="text-xs text-muted-foreground">Forever</p>
              </div>
            </div>
          </div>
        </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 hidden sm:block animate-bounce">
          <div className="w-10 h-10 rounded-full border-2 border-primary/30 flex items-center justify-center">
            <ArrowDown className="w-5 h-5 text-primary" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
